module.exports = __webpack_public_path__ + "static/Sam_Fraine-558abd9e97fd70314f87885d128cbe5f.png";